<template lang="pug">
  div
    b-row
      .col-xl-12
        panel(:title='$t("ui.daily_winlose_platform")' reportDetails=1)
          b-card
            b-row.flex(slot="header")
              .col-sm-12.col-md-6.col-lg-8.col-xl-6.mb-1
                DatePicker
              .col-sm-12.col-md-6.col-lg-6.col-xl-2.mb-1
                b-input-group(:prepend="$t('ui.member_id')" size="sm")
                  DebounceInput(
                    type="text"
                    ref="member_id"
                    :placeholder='$t("ui.member_id")'
                    v-model="member_id"
                    size="sm"
                    @keyup.enter.native="submit"
                  )
              pendingMatches.mb-1
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.mb-1
                b-alert.alert-sm.animated.flash(:show="!submission.success" variant="danger") {{ $t(submission.status) }}
              .col-sm-12.col-md-12.col-lg-12.col-xl-12.d-flex
                SubmitButton(:loading="loading" icon="fa fa-search" :text="$t('ui.search')" isModal=false type="button" @click="submit")
                .ml-auto
                  jsonToExcel(v-if="dailyWinlosePlatformList.length > 0" mode="WinloseByPlatform" :date="dateRange")
            b-row.mb-2(v-if="lines")
              .col-sm-12.col-md-12.col-lg-12.col-xl-12
                b-breadcrumb.bg-grey-transparent-3.p-l-10
                  b-breadcrumb-item(
                    v-for="(item,index) in lines"
                    :key="index"
                    :text="item.account_id.toUpperCase()"
                    :class="{ active: index==lines.length-1 }"
                    :title="$helpers.getUplineName(item.account_type)"
                    @click="redirectTo(item.account_id, 'dailyWinlose')"
                  )
            platformWinlose(:list="dailyWinlosePlatformList" @clicked="redirectTo(null, 'gameResult')")
</template>

<script>
import config from "@/config";
import { required } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import pendingMatches from "@/components/report/pendingMatches.vue";
import DatePicker from "@/library/DatePicker.vue";
import platformWinlose from "@/components/report/platformWinloseDetail.vue";
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    pendingMatches,
    platformWinlose,
    DatePicker,
    jsonToExcel
  },
  data() {
    return {
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      downlineLevel: this.$store.getters.accountType,
      dailyWinlosePlatformList: [],
      member_id: this.$store.getters.getSelectedID,
      lines: this.$store.getters.getTier
    };
  },
  validations: {},
  computed: {
    dateRange() {
      return {
        startDate: this.$moment(this.$store.getters.dateRange.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.$store.getters.dateRange.endDate).format("YYYY-MM-DD")
      }
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    redirectTo: function(id, page) {
      if(id) {
        this.$store.dispatch("user/setSelectedID", id)
        this.$router.push("/" + page)
      } else {
        if(this.member_id) {
          this.$store.dispatch("user/setSelectedID", this.member_id)
          this.$router.push("/" + page)
        }
      }
    },
    sortingChanged(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable("tblList")
    },
    refreshTable(table) {
      this.$root.$emit("bv::table::refresh", table)
    },
    submit: function() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let url = config.getPlatformWinloseDetailUrl()
        let search_id = (this.member_id == "") ? this.$store.getters.accountID : this.member_id
        let start_date = this.dateRange.startDate
        let end_date = this.dateRange.endDate
        this.loading = true
        this.$store
          .dispatch("user/getPlatformWinlose", { url, search_id, start_date, end_date })
          .then(response => {
            console.log(response)
            this.clearTotal()
            this.loading = false
            this.submission.success = response.success
            this.submission.status = response.errorTag
            if (this.submission.success == true) {
              if(response.data.length > 0) {
                this.dailyWinlosePlatformList = response.data
              } else {
                this.clearTotal()
              }
            } else {
              this.loading = false
              this.submission.success = response.success
              this.submission.status = response.errorTag
            }
          })
          .catch(response => {
            this.loading = false
            this.clearTotal()
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag)
          });
      }
    },
    clearTotal() {
      this.$store.dispatch("user/setSelectedID", "")
      this.showTotal = false
      this.dailyWinlosePlatformList = []
      this.grandTotalBetCount = 0
      this.grandTotalTurnover = 0
      this.grandTotalValidTurnover = 0
      this.grandTotalGrossCommission = 0
      this.grandTotalMemberWinlose = 0
      this.grandTotalMemberCommission = 0
      this.grandTotalMemberWinloseCommission = 0
    },
  }
};
</script>